import React, { useEffect, useState, useRef } from 'react';
import './header.css';
import Logotype from '../assets/logo-still-light.gif';
// import Logomark from '../assets/logomark.svg';
import ForIphone from '../assets/for-iphone.png';
import ForIpad from '../assets/for-ipad.png';
import ForMac from '../assets/for-mac.png';
import ForIMessage from '../assets/for-imessage.png'; 

function Header() {
    const [isSubmenuOpen, setSubmenuOpen] = useState(false);
    const [isMobileView, setIsMobileView] = useState(false);
    const submenuRef = useRef(null);

    // Close the submenu when clicking outside or when the mouse leaves both link and submenu
    useEffect(() => {
        function handleMouseLeave() {
            setSubmenuOpen(false);
        }

        document.addEventListener("mouseleave", handleMouseLeave);

        return () => {
            document.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, []);

    const handleMouseEnter = () => {
        setSubmenuOpen(true);
    };

    const handleMouseLeave = () => {
        setSubmenuOpen(false);
    };

    // submenu
    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 900);
        };

        handleResize(); // Check on first render
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const toggleSubmenu = () => {
        setSubmenuOpen(!isSubmenuOpen);
    };

    return (
        <header>
            <div > {/* style={{ backgroundImage: 'url(' + Paper + ')' }} */}

            {isMobileView ? (
                <div className="header-container-mobile">
                    {/* <svg Add your SVG for the menu icon></svg> */}
                    <div>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"></svg>
                    </div>
                    <div>
                        <a href="/"><img id="logotype" alt="logo" src={Logotype} /></a>
                    </div>
                    <svg onClick={toggleSubmenu} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.6875 5.12495C5.31824 5.12495 6.93103 5.18745 8.5625 5.18745C10.2061 5.18745 11.8487 4.9286 13.4965 5.06592C14.7526 5.1706 15.9794 5.24995 17.25 5.24995C17.8079 5.24995 18.3657 5.24995 18.9236 5.24995C19.1149 5.24995 19.9816 5.1507 20.0625 5.31245" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M3.6001 12.0625C4.3351 12.0625 4.57627 12.125 5.3125 12.125C6.04968 12.125 6.7845 12.0625 7.51389 12.0625C9.29297 12.0625 11.0888 12 12.875 12C14.2673 12 15.6478 11.9375 17.0312 11.9375C18.0624 11.9375 19.0834 12 20.125 12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M4.25 19.125C4.96065 19.125 5.6713 19.125 6.38194 19.125C6.89616 19.125 7.43321 19.1814 7.9375 19.2535C8.51613 19.3361 9.11704 19.3125 9.71181 19.3125C9.99537 19.3125 10.2789 19.3125 10.5625 19.3125C10.8156 19.3125 11.0761 19.1875 11.3264 19.1875C12.0586 19.1875 12.7758 19.25 13.5069 19.25C13.8996 19.25 14.2656 19.125 14.6528 19.125C14.8947 19.125 15.1366 19.125 15.3785 19.125C16.0792 19.125 16.7656 19.1875 17.4688 19.1875C17.9252 19.1875 18.3703 19.25 18.8125 19.25C19.2623 19.25 19.7341 19.4011 20.1875 19.25" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                </div>
            ) : (
                <div className="header-container">
                    <ul className="nav-left">
                        <li
                            className={`has-submenu ${isSubmenuOpen ? 'open' : ''}`}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                        >
                            <a className="nav-item fadeIn" href="#">Let's Play</a>
                            <div className="submenu">
                                <ul className="submenu-container" ref={submenuRef}>
                                    <li>
                                        <a href="https://apps.apple.com/us/app/skwiz/id1611258643?platform=iphone" target="_blank" rel="noreferrer">
                                            <img src={ForIphone} alt="iphone"/>
                                            <div className="submenu-description">
                                                <span className="submenu-description-title">iPhone</span>
                                                <span className="submenu-description-text">Draw wherever you go.</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://apps.apple.com/us/app/skwiz/id1611258643?platform=ipad" target="_blank" rel="noreferrer">
                                            <img src={ForIpad} alt="iPad" />
                                            <div className="submenu-description">
                                                <span className="submenu-description-title">iPad</span>
                                                <span className="submenu-description-text">Works with Apple Pencil.</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://apps.apple.com/us/app/skwiz/id1611258643?platform=mac" target="_blank" rel="noreferrer">
                                            <img src={ForMac} alt="Mac"/>
                                            <div className="submenu-description">
                                                <span className="submenu-description-title">Mac</span>
                                                <span className="submenu-description-text">For when you're at work.</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://apps.apple.com/us/app/skwiz/id1611258643?platform=messages" target="_blank" rel="noreferrer">
                                            <img src={ForIMessage} alt="iMessage" />
                                            <div className="submenu-description">
                                                <span className="submenu-description-title">iMessage</span>
                                                <span className="submenu-description-text">Play directly with friends.</span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li><a className="nav-item fadeIn" href="./events">Events</a></li>
                        {/* <li><a className="nav-item fadeIn" href="">Features</a></li> */}
                        {/* <li><a className="nav-item fadeIn" href="">What's New</a></li> */}
                    </ul>
                    <div>
                        <a href="/"><img id="logotype" alt="logo" src={Logotype} /></a>
                    </div>
                    <ul className="nav-right">
                        <li><a className="nav-item fadeIn" href="mailto:support@skwiz.co">Support</a></li>
                        <li><a className="nav-item fadeIn" href="./press">Press</a></li>
                    </ul>
                </div>
            )}

            {isMobileView && isSubmenuOpen && (
                <div className="submenu-mobile">
                    <ul className="submenu-mobile-container">
                        <li>
                            <a href="https://apps.apple.com/us/app/skwiz/id1611258643?platform=iphone" target="_blank" rel="noreferrer">

                                <div className="submenu-mobile-description">
                                    <span className="submenu-mobile-description-title">Let's Play</span>
                                </div>
                            </a>
                        </li>
                        {/* <li>
                            <a href="https://apps.apple.com/us/app/skwiz/id1611258643?platform=ipad" target="_blank">

                                <div className="submenu-mobile-description">
                                    <span className="submenu-mobile-description-title">Features</span>
                                </div>
                            </a>
                        </li> */}
                        <li>
                            <a href="mailto:support@skwiz.co">

                                <div className="submenu-mobile-description">
                                    <span className="submenu-mobile-description-title">Support</span>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="./press">

                                <div className="submenu-mobile-description">
                                    <span className="submenu-mobile-description-title">Press</span>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="./events">

                                <div className="submenu-mobile-description">
                                    <span className="submenu-mobile-description-title">Events</span>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            )}

            </div>
        </header>
    );
}

export default Header;
